import {Link as RouterLink} from "react-router-dom";
import {Box, Typography} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";

function ChildContactCard({contact}) {
  const fullName = `${contact.firstName ?? ''} ${contact.lastName ?? ''}`.trim();
  return (
    <Box
      component={RouterLink}
      to={`/contacts/${contact.id}`}
      sx={{
        display: 'flex',
        gap: 1.5,
        alignItems: 'flex-start',
        textDecoration: 'none',
        color: 'inherit',
        border: '1px solid #e0e0e0',
        borderRadius: 1,
        padding: 2,
        backgroundColor: '#fff',
        height: '100%',
        boxSizing: 'border-box',
        transition: 'border-color 120ms, box-shadow 120ms',
        '&:hover': {
          borderColor: 'primary.main',
          boxShadow: 1,
        },
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          backgroundColor: 'transparent',
          border: '1px solid',
          borderColor: 'action.active',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <PersonIcon sx={{color: 'action.active', fontSize: 24}}/>
      </Box>
      <Box sx={{minWidth: 0, flexGrow: 1}}>
        <Typography variant="body1" sx={{fontWeight: 500, wordBreak: 'break-word'}}>
          {fullName || `Contact #${contact.id}`}
        </Typography>
        {contact.email && (
          <Typography variant="body2" color="textSecondary" sx={{wordBreak: 'break-all'}}>
            {contact.email}
          </Typography>
        )}
        {contact.function && (
          <Typography variant="caption" color="textSecondary" sx={{display: 'block', mt: 0.5}}>
            {contact.function}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default ChildContactCard;
